import { ArrowUpRight } from "lucide-react";
import { SERVICES, whatsappFor } from "@/data/content";

// Simplified bento: 3 rows
const SPANS = {
    "ev-temizligi": "md:col-span-8",
    "ofis-temizligi": "md:col-span-4",
    "arac-ici-temizligi": "md:col-span-4",
    "cam-temizligi": "md:col-span-4",
    "kafe-restaurant": "md:col-span-4",
    "is-yeri-temizligi": "md:col-span-6",
    "insaat-sonrasi": "md:col-span-6",
};

const ServiceCard = ({ service, span, large }) => {
    return (
        <a
            href={whatsappFor(service.waText)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`service-card-${service.id}`}
            className={`onx-card group col-span-1 ${span} relative flex flex-col overflow-hidden cursor-pointer`}
        >
            <div
                className={`relative w-full overflow-hidden ${
                    large ? "aspect-[16/9]" : "aspect-[4/3]"
                }`}
            >
                <img
                    src={service.image}
                    alt={service.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B2B]/55 via-[#0B1B2B]/5 to-transparent" />
                <div className="absolute top-4 left-4">
                    <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/95 px-3 py-1 rounded-full bg-[#0055FF]/85 backdrop-blur">
                        Hizmet
                    </span>
                </div>
                <div className="absolute top-4 right-4">
                    <div className="w-10 h-10 rounded-full bg-white/95 backdrop-blur flex items-center justify-center transition-transform duration-500 group-hover:rotate-45">
                        <ArrowUpRight className="w-4 h-4 text-[#0055FF]" />
                    </div>
                </div>
            </div>
            <div className="p-5 sm:p-6 flex-1 flex flex-col">
                <h3
                    className={`${
                        large ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl"
                    } font-bold tracking-tight text-[#0B1B2B]`}
                >
                    {service.title}
                </h3>
                <p className="mt-2 text-sm sm:text-base text-[#4A6177] leading-relaxed">
                    {large ? service.description : service.short}
                </p>
                <div className="mt-auto pt-4">
                    <div className="pt-4 border-t border-[#0055FF]/10 flex items-center justify-between">
                        <span className="text-xs font-bold uppercase tracking-widest text-[#0055FF]">
                            WhatsApp ile Sor
                        </span>
                        <span className="text-xs font-semibold text-[#4A6177] group-hover:text-[#0055FF] transition-colors">
                            Detay →
                        </span>
                    </div>
                </div>
            </div>
        </a>
    );
};

export const Services = () => {
    return (
        <section
            id="hizmetler"
            data-testid="services-section"
            className="py-24 sm:py-32 bg-[#F4F8FB] relative overflow-hidden"
        >
            <div className="onx-container relative">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 sm:mb-16">
                    <div className="max-w-2xl">
                        <div className="onx-overline mb-4">
                            Hizmetlerimiz
                        </div>
                        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-[-0.03em] leading-[0.95] text-[#0B1B2B]">
                            Her mekâna özel <br />
                            <span className="text-[#0055FF]">
                                profesyonel çözüm.
                            </span>
                        </h2>
                    </div>
                    <p className="max-w-md text-sm sm:text-base text-[#4A6177] leading-relaxed">
                        Konuttan ticari alana, araç içinden inşaat sonrasına
                        kadar her ihtiyaca özel paketler. Hepsi tek bir
                        WhatsApp mesajı uzağınızda.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-5 sm:gap-6">
                    {SERVICES.map((s) => (
                        <ServiceCard
                            key={s.id}
                            service={s}
                            span={SPANS[s.id]}
                            large={s.id === "ev-temizligi"}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};
